import { createFeatureSelector, createSelector } from "@ngrx/store";
import { buildBrandBgEntity } from "@youm-front/brand/utils/factory";
import { ROOM_BRAND_BG_FEATURE_KEY, RoomBrandBgState } from "../reducers";

const roomBrandBgState = createFeatureSelector<RoomBrandBgState>(
  ROOM_BRAND_BG_FEATURE_KEY
);

export const brandBg = createSelector(
  roomBrandBgState,
  (state: RoomBrandBgState) =>
    state.brandBg ? buildBrandBgEntity(state.brandBg) : null
);

export const isLoading = createSelector(
  roomBrandBgState,
  (state: RoomBrandBgState) => state.isLoading
);
